export default __webpack_public_path__ + "dbaf6b31cf5b1ae0e86f8a6aa2c302e9.png";